<i18n src="./../../i18n/consent_form.json"></i18n>

<template>
    <div id="form-consent" class="row p-0 m-0 no-gutters mt-3 pb-4">
        <div class="col-lg-12 mt-product-main-details pl-4 pr-4 pt-4 pb-3">
            <p class="font-weight-bold mt-fs-x-large pt-2" v-text="$t('title')"/>
        </div>

        <div class="row p-row no-gutters pl-3">
            <div class="col-auto p-checkbox align-content-start">
                <input id="statConsent" class="form-check-input" type="checkbox" v-model="consentForm.statConsent"/>
            </div>
            <div class="col pl-2">
                <label for="statConsent" class="form-check-label" v-html="$t('consent1')"/>
            </div>
        </div>

        <div class="row p-row no-gutters pl-3 mt-3">
            <div class="col-auto p-checkbox align-content-start">
                <input id="owuConsent" class="form-check-input" type="checkbox" v-model="consentForm.owuConsent"/>
            </div>
            <div class="col pl-2">
                <label for="owuConsent" class="form-check-label" v-html="$t('consent3')"/>
            </div>
        </div>

        <div class="row p-row no-gutters pl-3 mt-3">
            <div class="col-auto p-checkbox align-content-start">
                <input id="adConsent" class="form-check-input" type="checkbox" v-model="consentForm.adConsent"/>
            </div>
            <div class="col pl-2">
                <label for="adConsent" class="form-check-label pb-3" v-html="showFullText ? adConsentText : truncatedAdConsentText"/>
                <span v-if="!showFullText" class="more" v-on:click="toggleText">{{ $t('more') }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";

    export default {
        name: "ConsentForm",
        components: {},
        props: {
            consentForm: {}
        },
        data () {
            return {
                adConsentText: this.$t('consent2'),
                truncateLength: 220,
                showFullText: false,
            }
        },
        computed: {
            truncatedAdConsentText() {
                // Użyj bezpiecznego przycinania HTML
                return this.truncateHtml(this.adConsentText, this.truncateLength);
            }
        },
        methods: {
            validate() {
                let valid = true

                // regulamin
                if (!this.consentForm.statConsent) {
                    valid = false
                    $('#statConsent').addClass('consent-error')
                } else {
                    $('#statConsent').removeClass('consent-error')
                }

                // OWU
                if (!this.consentForm.owuConsent) {
                    valid = false
                    $('#owuConsent').addClass('consent-error')
                } else {
                    $('#owuConsent').removeClass('consent-error')
                }

                return valid;
            },
            toggleText() {
                this.showFullText = !this.showFullText;
            },
            truncateHtml(html, maxLength) {
                let parser = new DOMParser();
                let doc = parser.parseFromString(html, 'text/html');
                let textContent = doc.body.textContent || "";

                // Sprawdź, czy długość tekstu przekracza maksymalną długość
                if (textContent.length <= maxLength) {
                    return html; // Zwróć pełny tekst, jeśli nie jest dłuższy niż limit
                }

                // Przytnij tekst, ale zakończ go na całym słowie
                let truncatedText = textContent.substring(0, maxLength);
                let lastSpaceIndex = truncatedText.lastIndexOf(' ');

                // Jeśli w przyciętym tekście jest spacja, obcinamy po ostatnim pełnym słowie
                if (lastSpaceIndex > 0) {
                    truncatedText = truncatedText.substring(0, lastSpaceIndex) + '...';
                } else {
                    truncatedText += '...'; // Dodaj "..." jeśli nie ma spacji (np. przy krótkim tekście)
                }

                // Funkcja do przywracania struktury HTML
                function restoreHtml(node, remainingText) {
                    if (remainingText.length === 0) return '';

                    if (node.nodeType === Node.TEXT_NODE) {
                        return remainingText.length >= node.textContent.length
                            ? node.textContent
                            : remainingText.substring(0, remainingText.length);
                    }

                    let restored = '';
                    for (let child of node.childNodes) {
                        restored += restoreHtml(child, remainingText);
                        remainingText = remainingText.substring(child.textContent.length);
                    }
                    return `<${node.nodeName.toLowerCase()}>${restored}</${node.nodeName.toLowerCase()}>`;
                }

                return restoreHtml(doc.body, truncatedText);
            }
        }
    }
</script>

<style scoped>
    .consent-error {
        border: 2px solid red !important;
    }

    .p-checkbox {
        padding-left: 25px;
        padding-right: 0;
    }

    .p-checkbox input {
        width: 15px;
        height: 15px;
        appearance: none;
        background-color: #fff;
        outline: 1px solid #6c6c6c;
        border-radius: 2px;
        position: relative;
    }

    .p-checkbox input:checked {
        background: #4092e5;
        border: 2px solid #fff;
    }

    .p-row label {
        font-size: smaller;
    }

    .more {
        color: #6c6c6c;
        font-weight: 300;
        cursor: pointer;
    }
</style>